module.exports = __webpack_public_path__ + "img/tbg.2c81ae41.png";